<div class="schedule-container">
  <h3>Horarios</h3>
  <p>Configuración de horarios de apertura y cierre del local.</p>
  <p>Location ID: {{ locationId }}</p>
</div>
